import { useState } from "react";
import { Madeira } from "../../../interfaces/madeira.interface";
import Botao from "../../Botao";
import http from "../../http";
import { useNavigate } from "react-router-dom";
import styles from './FormCriaProcesso.module.scss'

interface Props {
    madeiras: Madeira[];
    depreciacao: number;
    energia: number;
    maoDeObra: number;
    quantidadeFinal: number;
    despesaMadeira: number;
}

export default function FormCriaProcesso({ madeiras, depreciacao, energia, maoDeObra, quantidadeFinal, despesaMadeira }: Props) {
    const navigate = useNavigate();

    const [tipoProcesso, setTipoProcesso] = useState<string>('');
    const [produto, setProduto] = useState<string>('');

    const criarProcesso = async (e: React.FormEvent) => {
        e.preventDefault();

        let concatenaId = '';
        if (madeiras.length <= 1 && typeof madeiras[0].id === 'string') {
            concatenaId = madeiras[0].id;
        } else {
            concatenaId = madeiras.map(madeira => madeira.id).join(',');
        }

        const novoProcesso = {
            madeiraId: concatenaId,
            quantidadeDeEntrada: quantidadeFinal,
            tipoProcesso: tipoProcesso,
            produto: produto,
            inicio: new Date().toISOString(),
            fim: new Date().toISOString(),
            despesaEnergia: energia,
            despesaColaborador: maoDeObra,
            despesaMaquina: depreciacao,
            despesaInsumos: 0,
            despesaMadeira: despesaMadeira,
            finalizado: false,
        };

        try {
            await http.post('processos', novoProcesso);
            alert('Processo criado com sucesso!');
            navigate('/processos');
        } catch (error) {
            alert('Erro ao criar processo: ' + error);
        }
    };

    return (
        <form className={styles.formulario}>
            <label className={styles.formLabel}>Madeiras utilizadas</label>
            {madeiras.map((madeira) => (
                <h1 key={madeira.id} className={styles.madeiraCodigo}>{madeira.COD}</h1>
            ))}

            <label className={styles.formLabel}>Tipo de Processo</label>
            <input
                className={styles.inputCampo}
                required
                type="text"
                value={tipoProcesso}
                onChange={(e) => setTipoProcesso(e.target.value)}
            />

            <label className={styles.formLabel}>Produto</label>
            <input
                className={styles.inputCampo}
                required
                type="text"
                value={produto}
                onChange={(e) => setProduto(e.target.value)}
            />

            <h2 className={styles.tituloDespesas}>Despesas com máquinas</h2>
            <p className={styles.valorDespesas}>R$ {depreciacao}</p>

            <h2 className={styles.tituloDespesas}>Despesas com energia</h2>
            <p className={styles.valorDespesas}>R$ {energia}</p>

            <h2 className={styles.tituloDespesas}>Despesas com mão de obra</h2>
            <p className={styles.valorDespesas}>R$ {maoDeObra}</p>

            <button className={styles.botao} onClick={criarProcesso}>
                Confirmar
            </button>
        </form>
    );
}
